/* eslint-disable */
import { produce } from "immer";
import {
  ABOUT_TPT_FETCH_START,
  ABOUT_TPT_FETCH_SUCCESS,
  ABOUT_TPT_FETCH_FAILURE,
} from "../actions/types";

const AboutTPT = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case ABOUT_TPT_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case ABOUT_TPT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case ABOUT_TPT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default AboutTPT;
